enum AWSRegionEnum {
  USEast1 = 'us-east-1',
  USEast2 = 'us-east-2',
  USWest2 = 'us-west-2',
  CACentral1 = 'ca-central-1',
}

export default AWSRegionEnum
